import "./line-chart.scss";
import {Chart} from 'chart.js/auto';

export default function LineChart() {
    const dataChart = document.querySelector('.line-chart-data') as HTMLElement;
    let data: any;
    const $lineChart = document.querySelectorAll('.line-chart');

    if ($lineChart.length) {
        $lineChart.forEach($el => {
            if (dataChart) {
                try {
                    data = JSON.parse(dataChart.innerHTML);
                } catch (e) {
                    data = [];
                }
            }
            function addAnd(str: string) {
                const words = str.split(' ')
                if (words.length == 2) {
                    return str
                }

                words.splice(words.length - 1, 0, '\n')

                return words.join(' ')
            }

            let splitDate : any = [];
            data[0].date.map((item: any) => {
                splitDate.push(addAnd(item))
            })

            // @ts-ignore
            const chart = new Chart($el.querySelector('.line-chart-content') as HTMLCanvasElement, {
                type: 'line',
                data: {
                    labels: splitDate,
                    datasets: [
                        {
                            data: data[0].value,
                            fill: false,
                            tension: 0.4,
                            pointBorderColor: 'white',
                            pointBackgroundColor: '#003366',
                            borderWidth: 4,
                            pointRadius: 13,
                            pointHoverRadius: 13,
                            pointHoverBorderWidth: 4,
                            pointHoverBorderColor: 'white',
                            borderColor: '#003366',
                            pointStyle: 'circle',
                        }, {
                            data: data[1].value,
                            fill: false,
                            tension: 0.4,
                            pointBorderColor: 'white',
                            borderWidth: 4,
                            pointRadius: 13,
                            pointHoverRadius: 13,
                            pointHoverBorderWidth: 4,
                            pointHoverBorderColor: 'white',
                            pointBackgroundColor: '#0066CC',
                            borderColor: '#0066CC',
                            pointStyle: 'circle'
                        },
                    ]
                },
                plugins: [{
                    id: 'label',
                    beforeInit: function(chart) {
                        chart.data.labels?.forEach(function(e: any, i, a) {
                            if (/\n/.test(e)) {
                                a[i] = e.split(/\n/);
                            }
                        });
                    }
                }],
                options: {
                    responsive: true,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                // @ts-ignore
                                title: function (context) {
                                    let title = context[0].parsed.y;
                                    return title;
                                },
                                label: function() {
                                    return '';
                                }
                            },
                            backgroundColor: 'white',
                            cornerRadius: 8,
                            bodyColor: 'black',
                            bodyFont: {
                                size: 20
                            },
                            titleFont: {
                                size: 32
                            },
                            displayColors: false,
                            titleColor: 'black',
                            padding: 14,
                        },
                        legend: {
                            display: false,
                        },
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false,
                            },
                            ticks: {
                                padding: 26,
                                display: true,
                                color: 'black',
                                font: {
                                    weight: 'normal',
                                    size: 17,
                                    family: "'Titillium Web', sans-serif",
                                }
                            }
                        },
                        y: {
                            border: {
                                display: false,
                            },
                            grid: {
                                tickColor: 'transparent',
                                tickLength: 20,
                            },
                            display: true,
                            ticks: {
                                callback: function (value) {
                                    return value + ' M';
                                },
                                autoSkipPadding: 55,
                                display: true,
                                color: 'black',
                                font: {
                                    weight: 'normal',
                                    size: 17,
                                    family: "'Titillium Web', sans-serif",
                                }
                            }
                        }
                    },
                }
            });

        })
    }
}